import { Container } from "react-bootstrap";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

export default function KeyFeatures(): ReactElement {
  const { t } = useTranslation();
  const keyFeaturesData = [
    {
      imgSrc: "/assets/img/cashlessHospitalizationHealth.svg",
      title: t("choose_us_cashless_hospitalization"),
      description: t("sme_key_features_cashless_hospitalization_description")
    },
    {
      imgSrc: "/assets/img/temporaryDisability-pa.svg",
      title: t("travel_medical_emergencies"),
      description: t("sme_key_features_medical_emergencies_description")
    },
    {
      imgSrc: "/assets/img/medicalExamHealth.svg",
  "health_plan_details_pre_existing_condition_heading": "Pre-Existing Conditions",
      title: t("health_plan_details_pre_existing_condition_heading"),
      description: t("sme_key_features_pre_existing_condition_description")
    },
    {
      imgSrc: "/assets/img/accidentalMed-pa.svg",
      title: t("covered_medical_examination"),
      description: t("sme_key_features_medical_examination_description")
    }
  ];
  return (
    <div className="landing-page-wrapper mt-5">
      <section className="exclusion-section keyFeatures-pa my-health-takaful-bnr">
        <Container>
          <h1 className="mhtb-title text-center mb-5">
            {t("travel_key")} <span className="text-primary">{t("travel_features")}</span>
          </h1>
          <div className="row">
            {keyFeaturesData.map((feature, index) => (
              <div
                className="col-md-6 mb-2 mb-md-4"
                key={index}
              >
                <div className="row pa-kf-box mx-0 align-items-center">
                  <div className="col-3 text-center">
                    <img
                      src={feature.imgSrc}
                      alt={feature.title}
                    />
                  </div>
                  <div className="col-9">
                    <h4 className="pa-kf-heading mb-1">{feature.title}</h4>
                    <p className="pa-kf-subheading mb-0">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
